"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomShapePainter = void 0;
var ShapePainter_1 = require("../ShapePainter");
var executeSvgPath_1 = require("../../../util/executeSvgPath");
var antiAliasSize = 1;
/**
 * Implements drawing-related operations for custom shapes.
 */
var CustomShapePainter = /** @class */ (function (_super) {
    __extends(CustomShapePainter, _super);
    function CustomShapePainter() {
        var _this = _super.call(this, "custom-shape") || this;
        _this.baseWidthOf = function (object) { return object.width; };
        _this.baseHeightOf = function (object) { return object.height; };
        return _this;
    }
    /**
     * Traces a custom SVG path.
     */
    CustomShapePainter.prototype.tracePath = function (ctx, store, object) {
        var e_1, _a;
        ctx.save();
        ctx.translate(0.5, 0.5);
        // Scale path to match object size:
        ctx.scale((this.scaledBaseWidthOf(object) - antiAliasSize) / object.clipViewBoxWidth, (this.scaledBaseHeightOf(object) - antiAliasSize) / object.clipViewBoxHeight);
        ctx.beginPath();
        try {
            for (var _b = __values(object.clipPaths), _c = _b.next(); !_c.done; _c = _b.next()) {
                var clipPath = _c.value;
                executeSvgPath_1.executeSvgPath(clipPath, ctx);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        ctx.closePath();
        ctx.restore();
    };
    CustomShapePainter.prototype.useLineJoinRoundWhenApplyingStroke = function (object) {
        return object.clipPaths.every(function (path) { return path.endsWith('Z Z'); });
    };
    CustomShapePainter.prototype.needsMiterOvershoot = function (object) {
        return true;
    };
    return CustomShapePainter;
}(ShapePainter_1.ShapePainter));
exports.CustomShapePainter = CustomShapePainter;
//# sourceMappingURL=CustomShapePainter.js.map